module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website-w540.07937dd1.jpg";